export const reduceAbstract = (abstract: string) => {
  try {
    const tags = /(<([^>]+)>)/gi
    return abstract.replace(tags, '')
  } catch {
    return ''
  }
}

interface UsePercentProps {
  value: number
  total?: number
  finished?: boolean
}

export const calcPercent = ({ finished, value, total }: UsePercentProps) => {
  const percentCalculated = total
    ? parseFloat(((value / total) * 100).toFixed())
    : 0
  const percentLessonsCompleted = isNaN(percentCalculated)
    ? 0
    : percentCalculated
  return finished ? 100 : percentLessonsCompleted
}
